import React, { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { TermsModal } from "@/components/site/TermsModal";
import { PrivacyModal } from "@/components/site/PrivacyModal";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <footer className="relative bg-[#0A0A0B] border-t border-white/10 pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-7">
            <p className="max-w-md text-zinc-400 text-lg leading-relaxed">{f.tagline}</p>
            <div className="mt-6 flex flex-col gap-1">
              <a href={`tel:${t.contact.phoneHref}`} data-testid="footer-phone" className="font-serif-display text-white text-xl hover:text-gold transition-colors duration-300">
                {t.contact.phone}
              </a>
              <a href={`mailto:${t.contact.emailValue}`} data-testid="footer-email" className="text-zinc-400 hover:text-gold transition-colors duration-300">
                {t.contact.emailValue}
              </a>
              <span data-testid="footer-address" className="text-zinc-500 text-sm mt-2 max-w-xs">
                {t.contact.address}
              </span>
            </div>
          </div>
          <div className="md:col-span-5 md:text-right">
            <span className="flo-label">{f.pay}</span>
            <div className="flex md:justify-end flex-wrap gap-2 mt-4">
              {["VISA", "Mastercard", "AMEX", "SWIFT", "BTC", "USDT"].map((b) => (
                <span key={b} className="text-xs tracking-wider text-zinc-300 border border-white/15 rounded px-3 py-1.5">
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="font-serif-display text-white leading-none tracking-tighter text-[18vw] md:text-[13vw] select-none border-t border-white/10 pt-8">
          FLODELICA
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mt-8 text-sm text-zinc-500">
          <span>© {year} FLODELICA. {f.rights}</span>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
            <button
              onClick={() => setTermsOpen(true)}
              data-testid="footer-terms-link"
              className="text-zinc-400 hover:text-gold underline underline-offset-4 decoration-white/20 hover:decoration-gold transition-colors duration-300"
            >
              {f.terms}
            </button>
            <button
              onClick={() => setPrivacyOpen(true)}
              data-testid="footer-privacy-link"
              className="text-zinc-400 hover:text-gold underline underline-offset-4 decoration-white/20 hover:decoration-gold transition-colors duration-300"
            >
              {f.privacy}
            </button>
            <span className="flo-label !text-[0.6rem]">{f.confidential}</span>
          </div>
        </div>
      </div>
      <TermsModal open={termsOpen} onOpenChange={setTermsOpen} />
      <PrivacyModal open={privacyOpen} onOpenChange={setPrivacyOpen} />
    </footer>
  );
};
